import { Button } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import PreviewTemplateDialog from '../widgetTemplates/PreviewTemplateDialog'

const ENDPOINT_BASE = 'widgets/initialScreenTemplates'

/**
 * Full-screen, read-only preview of a user's CURRENT initial screen (GET
 * user-screen/{userId}), opened from the user template catalog. Lets the admin
 * see the layout before snapshotting it into a template: the header "Create
 * template" action defers to the parent, which owns the name prompt and the
 * from-user POST. An empty screen previews as an empty grid.
 */
const UserScreenPreviewDialog = ({ open, user, onClose, onCreateTemplate }) => {
  const { t_ } = useSmartTranslation()

  return (
    <PreviewTemplateDialog
      open={open}
      loadPath={user ? ENDPOINT_BASE + '/user-screen/' + user.id : ''}
      subtitle={user ? user.username : ''}
      onClose={onClose}
      actions={
        <Button variant='contained' startIcon={<SaveIcon />} onClick={() => onCreateTemplate()}>
          {t_('Create template')}
        </Button>
      }
    />
  )
}

export default UserScreenPreviewDialog
